import { render, staticRenderFns } from "./ValueAssessment.vue?vue&type=template&id=53d0e2fc&scoped=true"
import script from "./ValueAssessment.vue?vue&type=script&lang=js"
export * from "./ValueAssessment.vue?vue&type=script&lang=js"
import style0 from "./ValueAssessment.vue?vue&type=style&index=0&id=53d0e2fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d0e2fc",
  null
  
)

export default component.exports